import { getEntity } from '../entities/selectors';
import { getActiveGroup, getGroupId } from '../session/selectors';

const getScope = (state) => state.supplier;

export const getSupplierById = (state, supplierId) =>
  getEntity(state, 'suppliers', supplierId);

export const getSuppliers = (state) => getScope(state).all;

export const getDefaultUnits = (state) => (getActiveGroup(state) || {}).units;

export const getTeamMembers = (state) => {
  const teamMembers = getScope(state).teamMembers;
  const groupId = getGroupId(state);
  return teamMembers.map((teamMember) => {
    const newTeamMember = { ...teamMember };
    if (teamMember.receivedInvites) {
      const invite = teamMember.receivedInvites.find(
        (invititation) => invititation.groupId === groupId,
      );
      if (invite) {
        newTeamMember.isInviteAccepted = invite.isAccepted;
        newTeamMember.isInviteExpired = invite.isExpired;
      }
    }
    return newTeamMember;
  });
};

export const getActiveTeamMember = (state) => getScope(state).activeTeamMember;

export const getIsActiveTeamMemberEmailVerified = (state) =>
  getScope(state).isActiveTeamMemberEmailVerified;

export const getIsEmailResendFetching = (state) =>
  getScope(state).isEmailResendFetching;

export const isCreatingTeamMember = (state) =>
  getScope(state).isCreatingTeamMember;
